import { render, staticRenderFns } from "./DatasetTable.vue?vue&type=template&id=1c0f4171&"
import script from "./DatasetTable.vue?vue&type=script&lang=js&"
export * from "./DatasetTable.vue?vue&type=script&lang=js&"
import style0 from "./DatasetTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports